import { createSelector } from 'reselect'
import { sum } from 'lib/array/arrayUtils'
import getCurrentPaymentSchedule from './getCurrentPaymentSchedule'

export const getServiceFeeForInitialPayment = createSelector(
  getCurrentPaymentSchedule,
  (paymentSchedule): number => {
    if (!paymentSchedule?.eligible || !paymentSchedule?.charges) {
      return 0
    }
    return paymentSchedule.charges[0]?.feeAmount || 0
  },
)

export const getPaymentScheduleTotalServiceFee = createSelector(
  getCurrentPaymentSchedule,
  (paymentSchedule): number => {
    if (!paymentSchedule?.eligible || !paymentSchedule?.charges) {
      return 0
    }
    return sum(paymentSchedule.charges, (schedule) => schedule.feeAmount)
  },
)

export const getServiceFeeForLaterPayments = createSelector(
  getPaymentScheduleTotalServiceFee,
  getServiceFeeForInitialPayment,
  (totalServiceFee, initialServiceFee): number => {
    return totalServiceFee - initialServiceFee
  },
)

export const getServiceFeePaymentScheduleData = createSelector(
  getCurrentPaymentSchedule,
  (paymentSchedule): App.PaymentScheduleServiceFeeData | undefined => {
    const chargeIndex = paymentSchedule?.charges?.findIndex(schedule => schedule.feeAmount > 0) ?? -1

    if (chargeIndex === -1 || !paymentSchedule?.charges?.[chargeIndex]) {
      return undefined
    }

    return {
      chargeIndex,
      feeAmount: paymentSchedule.charges[chargeIndex].feeAmount,
      paymentType: paymentSchedule.charges[chargeIndex].paymentType,
    }
  },
)
